import { formatTime, formatTimer, soonestAlarm, timerLeft, untilLabel } from '@obv/core';
import { useEffect, useState } from 'react';
import { useAlarms } from '@/queries/alarms';
import { useClockTools } from '../clockStore';
import { useDisplay } from '../context';

// Kept apart from the Clock page so the home screen can show it without loading that page.

/** Re-renders every `ms` while `active`, returning the current epoch time. */
export function useNow(active: boolean, ms: number): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!active) return;
    setNow(Date.now());
    const id = setInterval(() => setNow(Date.now()), ms);
    return () => clearInterval(id);
  }, [active, ms]);
  return active ? now : Date.now();
}

/** One quiet line under the home clock: a running timer, else the next alarm within a day. */
export function ClockStatus() {
  const ctx = useDisplay();
  const alarms = useAlarms();
  const timer = useClockTools((s) => s.timer);
  const running = timer.endsAt !== null;
  const now = useNow(running, 1000);
  let text: string | null = null;
  if (running) text = `Timer · ${formatTimer(timerLeft(timer, now))} left`;
  else if (alarms.data) {
    const s = soonestAlarm(alarms.data, ctx.clock.dateKey, ctx.clock.hhmm);
    if (s && s.minutesUntil <= 24 * 60) text = `Alarm ${formatTime(s.alarm.time, ctx.prefs.h24)} · ${untilLabel(s.minutesUntil)}`;
  }
  return text ? <div className="tabular mt-1 text-[14px] text-muted2">{text}</div> : null;
}
